import { markParlorExitVariation } from "@/utils/parlorExitLogin";
import { createContext, ReactNode, useContext, useEffect } from "react";
import { useRouter } from "next/router";
import { useCustomVariation } from "@/hooks/useCustomVariation";
import { isInsideEntry } from "@/utils/parlorBackTrapEntry";

const Context = createContext(false);
export const useParlorRequestB = () => useContext(Context);

export function ParlorRequestExperiment({ children }: { children: ReactNode }) {
  const router = useRouter();
  return router.pathname === "/match/parlor-requests/[id]" ? (
    <Experiment>{children}</Experiment>
  ) : (
    <>{children}</>
  );
}

function Experiment({ children }: { children: ReactNode }) {
  const variation = useCustomVariation(370, undefined, {
    entry_type: isInsideEntry() ? "inside" : "direct",
  });
  useEffect(() => {
    markParlorExitVariation(variation);
  }, [variation]);
  return <Context.Provider value={variation === "B"}>{children}</Context.Provider>;
}
